import { Injectable } from '@angular/core';
import { MasterDataRepository } from 'src/core/master-data/domain/master-data-repository';
import { MasterDataService } from 'src/core/master-data/domain/master-data-service';
import { MasterData } from 'src/core/master-data/domain/master-data';
import { TaskService } from 'src/core/tasks/domain/task.service';
import { FiltersService } from 'src/core/filters/domain/filters-service';
import { EventsService } from 'src/core/events/events.service';
import { MasterDataUpdatedEvent } from 'src/core/events/master-data-updated.event';
import { IsDownloadingMasterDataEvent } from 'src/core/events/is-downloading-master-data.event';
import { DescriptionFilesPrefetchService } from 'src/core/description-file-cache/domain/description-files-prefetch.service';
import { AnalyticsEvent } from 'src/core/analytics/analytics-event';
import { AnalyticsService } from 'src/core/analytics/analytics.service';
import { SessionService } from 'src/core/session/domain/session.service';

@Injectable({
  providedIn: 'any',
})
export class LoadMasterData {
  constructor(
    private masterDataRepository: MasterDataRepository,
    private masterDataService: MasterDataService,
    private eventsService: EventsService,
    private filtersService: FiltersService,
    private taskService: TaskService,
    private analyticsService: AnalyticsService,
    private sessionService: SessionService,
    private descriptionFilesPrefetchService: DescriptionFilesPrefetchService
  ) {}

  async execute(): Promise<MasterData> {
    this.eventsService.publishIsDownloadingMasterData(new IsDownloadingMasterDataEvent(true));
    try {
      const masterData = await this.masterDataRepository.load();
      await this.masterDataService.save(masterData);
      await this.taskService.saveTasks(masterData.tasks);

      await this.analyticsService.logEvent(AnalyticsEvent.TASK_LIST_LOAD, {
        sort_method: this.sessionService.getTasksSortMethodHumanReadable(),
        sort_method_internal_name: this.sessionService.getTasksSortMethod(),
      });

      // Disabled prefetch until decide the definitive behavior.
      // await this.descriptionFilesPrefetchService.prefetchTodayTaskDescriptionFiles(masterData.tasks);

      // 1a vegada, es posen els per defecte
      // posteriors, es resetegen date filtes
      await this.filtersService.updateFilters();
      this.eventsService.publishMasterDataUpdatedEvent(new MasterDataUpdatedEvent());
      return masterData;
    } catch (exception) {
      await this.masterDataService.markErrorOnDownload();
      throw exception; // propagate
    } finally {
      this.eventsService.publishIsDownloadingMasterData(new IsDownloadingMasterDataEvent(false));
    }
  }
}
